import { rem } from '../mixins/rem';

const breakpoints = {
  xs: '0',
  s: rem(768),
  m: rem(1024),
  l: rem(1280),
  xl: rem(1420),
  xxl: rem(1920),
};

export type Breakpoints = keyof typeof breakpoints;

export { breakpoints };
